// Fullscreen with our overlays (Seán, 2026-10-21): Vimeo's fullscreen makes only its own frame
// fullscreen (in Safari, Apple's video player), which leaves the video controls
// (SkipControls.vue) and the end screen outside. So where a page element can go fullscreen
// (desktop browsers, an iPad), Vimeo's button is hidden (its "fullscreen" option, Bespoke.vue)
// and ours makes the element around the player fullscreen. An iPhone can't: Vimeo's button
// stays, and opens Apple's player, which has its own ±10 s
import {ref} from "vue";
import {useEventListener} from "@vueuse/core";

export function getCanFullscreen() {
  if (typeof document === "undefined") return false;
  return Boolean(document.fullscreenEnabled || document.webkitFullscreenEnabled);
}

function getFullscreenElement() {
  return document.fullscreenElement || document.webkitFullscreenElement || null;
}

async function enterFullscreen(element) {
  const request = element.requestFullscreen || element.webkitRequestFullscreen;
  await request?.call(element)?.catch?.(() => {});
}

async function exitFullscreen() {
  const exit = document.exitFullscreen || document.webkitExitFullscreen;
  await exit?.call(document)?.catch?.(() => {});
}

export function useOverlayFullscreen(getContainer) {
  const isFullscreen = ref(false);
  function onChange() {
    isFullscreen.value = Boolean(getContainer()) && getFullscreenElement() === getContainer();
  }
  async function toggleFullscreen() {
    const container = getContainer();
    if (!container) return;
    if (isFullscreen.value) return exitFullscreen();
    await enterFullscreen(container);
  }
  useEventListener(document, "fullscreenchange", onChange);
  useEventListener(document, "webkitfullscreenchange", onChange);
  return {isFullscreen, toggleFullscreen};
}
